// react-tooltip v3 omits the event argument on its initial show callback.
export const getTooltipAnchorArgs = (eventOrTarget, targetOrNode, nodeOrPlace, place) => (
  typeof eventOrTarget?.getBoundingClientRect === 'function'
    ? { target: eventOrTarget, node: targetOrNode, place: nodeOrPlace }
    : { target: targetOrNode, node: nodeOrPlace, place }
)

export const getTooltipHorizontalPosition = (iconCenter, tooltipWidth, viewportWidth) => {
  const left = Math.max(8, Math.min(iconCenter - tooltipWidth / 2, viewportWidth - tooltipWidth - 8))
  return { left, arrowLeft: iconCenter - left }
}
